module.exports = __webpack_public_path__ + "static/media/p_35_0.f7489b92.png";